var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDxJankatsuMasterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 180,
    viewBox: "0 0 640 180",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "DX \u96C0\u6D3B\u30DE\u30B9\u30BF\u30FC") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153d85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#2563eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c759b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e8ca80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bd9142"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 10)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 104,
    fontFamily: "Arial Black,Arial,sans-serif",
    fontSize: 118,
    fontWeight: 900,
    fontStyle: "italic",
    letterSpacing: -10,
    fill: "url(#blue)"
  }, "DX"), /*#__PURE__*/React.createElement("path", {
    d: "M34 110 Q128 58 229 8 L218 28 Q141 95 34 110Z",
    fill: "url(#gold)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(218 10) rotate(8 34 35)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 74,
    x: 0,
    y: 0,
    rx: 12,
    fill: "#fff",
    stroke: "#1a7558",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 74,
    x: 4,
    y: 3,
    rx: 11,
    fill: "none",
    stroke: "#d7e1d9"
  }), /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 53,
    textAnchor: "middle",
    fontFamily: "serif",
    fontWeight: 800,
    fontSize: 49,
    fill: "#0e6848"
  }, "\u767C")), /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 85,
    fontFamily: "Yu Gothic, Hiragino Kaku Gothic ProN, Noto Sans CJK JP, sans-serif",
    fontSize: 48,
    fontWeight: 900,
    fill: "#122c54",
    letterSpacing: -2
  }, "\u96C0\u6D3B\u30DE\u30B9\u30BF\u30FC"), /*#__PURE__*/React.createElement("path", {
    d: "M281 103 Q444 129 604 100",
    stroke: "url(#gold)",
    strokeWidth: 7,
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    x: 288,
    y: 144,
    fontFamily: "Arial,sans-serif",
    fontSize: 15,
    fill: "#7184a1",
    letterSpacing: 3
  }, "MANAGEMENT SYSTEM"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDxJankatsuMasterLogo);
export default __webpack_public_path__ + "static/media/DX_Jankatsu_Master_Logo.1bd96517f3b04908edbb7f8d33f86df9.svg";
export { ForwardRef as ReactComponent };